import { axios } from './request'

let url = import.meta.env.VITE_API_URL
if (url === '') {
  url = window.location.protocol + '//api.' + window.location.host
}

export const websocket = {
  conn: null,
  connected: false,
  init() {
    if (window['WebSocket']) {
      if (Object.keys(window.vue.$store.state.auth.jwt).length > 0) {
        this.connect()
      }
    }
  },
  connect() {
    const wsUrl = url.replace(/^http/, 'ws')
    this.conn = new WebSocket(wsUrl + '/websocket')
    this.conn.onopen = () => {
      this.connected = true
      this.sendPing()
    }
    this.conn.onclose = () => {
      this.connected = false
      this.connect()
      setTimeout(() => {
        if (!this.connected) {
          window.vue.$store.dispatch('serverStatus', 'unreacheable')
        }
        //websocket.init()
      }, 1000)
    }

    this.conn.onmessage = function (evt) {
      const data = JSON.parse(evt.data)
      const event = new CustomEvent('ws:' + data.topic, { detail: data.payload })
      window.dispatchEvent(event)
    }
  },
  sendPing() {
    setTimeout(() => {
      if (this.connected) {
        this.conn.send(JSON.stringify({ topic: 'ping' }))
        this.sendPing()
      }
    }, 55000)
  },
}

window.addEventListener('ws:handshake', (data) => {
  if (Object.keys(window.vue.$store.state.auth.jwt).length > 0) {
    axios
      .post(url + '/websocket/auth', { connectionId: data.detail })
      .then(() => {})
      .catch((err) => {
        console.log(err)
      })
  }
})

window.addEventListener('ws:debug', (data) => {
  window.vue.$toasted.show(data.detail).goAway(3000)
})
